module.exports = __webpack_public_path__ + "static/media/Login.09706eb4.svg";